import { Component } from 'react';
import Header from '../../../Header';
import MessageLink from '../../../MessageLink';
import Footer from '../../../Footer';
import Cargo from '../../../Cargos';
import Lgpd from '../../../Lgpd';
import ErrorBoundary from '../../../ErrorHandler/ErrorBoundary';
import InfoComponent from '../../InfoComponent';

class Area extends Component {

	render() {

		return (


			<div>
				{/* HEADER */}{/* LOGIN */}
				<ErrorBoundary><Header /></ErrorBoundary>

				<InfoComponent image={window.location.pathname.replace('/','')} page={window.location.pathname.replace('/','')}></InfoComponent>		
			
				{/* Content page */}
				<ErrorBoundary><Cargo page={window.location.pathname.replace('/','')} /></ErrorBoundary>
				{/* FOOTER */}
				<ErrorBoundary><Footer /></ErrorBoundary>
				{/* Message Link */}
				<ErrorBoundary><MessageLink /></ErrorBoundary>
				{/* LGPD */}
				<ErrorBoundary><Lgpd /></ErrorBoundary>
			</div>
		);
	}
};

export default Area;